import React from 'react'
import { onCellEditComplete } from './common'
import MultiSelectComp from '../../form-components/dropdown/MultiSelectComp'

const dropdownEditor = ({
  optionsEditor,
  options,
  optionLabel,
  optionValue,
  filter,
}) => {
  return (
    <MultiSelectComp
      value={optionsEditor?.value?._id || optionsEditor?.value}
      options={options || []}
      optionLabel={optionLabel}
      optionValue={optionValue}
      onChange={({ target: { value } }) => optionsEditor.editorCallback(value)}
      filter={filter}
    />
  )
}

const editMultiselectRowColumn = ({
  options,
  optionLabel = 'name',
  optionValue = '_id',
  filter = false,
}) => {
  return {
    editor: (optionsEditor) =>
      dropdownEditor({
        optionsEditor,
        options,
        optionLabel,
        optionValue,
        filter,
      }),
    onCellEditComplete,
  }
}

export default editMultiselectRowColumn
